import {createSlice,createAsyncThunk} from "@reduxjs/toolkit"
import { filterUrls } from "../../../services/api.enums";
import { filterTableDataAPI } from "../../../services/CRUDServices";
import { ErrorAlert } from "global/alert/Alert";


export const filterGate=createAsyncThunk('routeLists',async(body:any)=>{

    var data:any;
    try {
      data = await filterTableDataAPI(filterUrls.gate as any, body?.pageNumber || 1,{
        ...body,
        pageNumber: undefined,
        pageSize: undefined,
      },true);
      } catch (error) {
        ErrorAlert(error?.response?.data?.errors?.message)
      }
    return data.data;
})

const initialState:any= {
    gateLists:[],
    fetchpost:false,
    errorMessage:null,
    isUpdating: false,
    filter:[]    
}

const GateLists= createSlice({
    initialState: initialState,
    name: "gateLists",
    reducers: {
          clearGate: (state) => {
            state.gateLists = [];
          },
          setFilter: (state, action) => {
            state.filter = action.payload;
          },
    },
    extraReducers: {
        [filterGate.fulfilled as any]: (state, action) => {
            state.gateLists = action.payload.payload;
            state.fetchPost = false;
        },
        [filterGate.pending as any]: (state) => {
            state.fetchPost = true;
        },
        [filterGate.rejected as any]: (state) => {
            state.fetchPost = false;
            state.errorMessage = "wrong";
        },
    },
});

export const {  setFilter ,clearGate} = GateLists.actions;
export default GateLists.reducer